<template>
  <v-card outlined class="py-3 px-5 w-100">
    <table class="w-100">
      <tr class="no-row-border">
        <td class="no-border" style="width: 170px"></td>
        <td
          class="table-title"
          style="direction: rtl"
          v-for="title in titles"
          :key="title"
        >
          {{ $t(`balanceResult.${title}`) }}
        </td>
      </tr>
      <tr v-for="key in keys" :key="key">
        <td class="table-title no-col-border">
          {{ $t(`balanceResult.${key}`) }}
        </td>
        <td v-for="(_title, index) in titles" :key="`${key}-${index}`">
          {{ product[index][key] }}
        </td>
      </tr>
    </table>
  </v-card>
</template>

<script>
import { PRODUCT_KEYS } from "../../views/balance/data";

export default {
  name: "ProductResult",

  props: {
    product: { type: Array, required: true },
  },

  data() {
    return {
      titles: ["pg", "png", "bustle"],
      keys: PRODUCT_KEYS,
    };
  },
};
</script>
